import { useEffect, useLayoutEffect, useState } from "react";
import { useRouter } from "next/router";

const useIsomorphicLayoutEffect =
  typeof window !== "undefined" ? useLayoutEffect : useEffect;

export function useIsFromPrime(): boolean {
  const router = useRouter();
  const [isFromPrime, setIsFromPrime] = useState(false);

  useIsomorphicLayoutEffect(() => {
    if (router.query.from === "prime") {
      window.sessionStorage.setItem("from_prime", "true");
      setIsFromPrime(true);
    } else {
      setIsFromPrime(window.sessionStorage.getItem("from_prime") === "true");
    }
  }, [router.query.from]);

  return isFromPrime;
}
